import mutations from './mutations'
import actions from './action'
import getters from './getters'


const state = {
  cartInfo: {}, // 加入购物车的商品列表
  noticeInfo: {},
  warehouseInfo:{},
  productInfo:{},
  productStockInfo:{},
  shopDetail: null, //商家详情信息

  addressData:null,

  latitude: '', // 当前位置纬度
  longitude: '', // 当前位置经度  
  shopid: null, //商铺id
  remarkText: null, //可选备注内容
  inputText: '', //输入备注内容
  invoice: false, //开发票
  newAddress: [], //确认订单页新的地址
  searchAddress: null, //搜索并选择的地址
  geohash: 'wtw3sm0q087', //地址geohash值
  choosedAddress: null, //选择地址
  addressIndex: null, //选择地址的索引值
  needValidation: null, //确认订单时是否需要验证
  cartId: null, //购物车id
  sig: null, //购物车sig
  orderParam: null, //订单的参数
  orderMessage: null, //订单返回的信息
  orderDetail: null, //订单详情
  contract:null, //协议

  imgPath: null, //头像地址
  removeAddress: [], //移除地址
  addAddress: '', //新增地址
  question: null, //问题详情
  cartPrice: null, //会员卡价格
  payrecord:null,//付款记录
  
  orderno:null,
  promote:null, //促销配置

  forCustomer:null,
  newpromoCode:{},  //
  charitable:{
    list:null,
    result:false
  },
  orderType:0,  //默认普通订单
  isOrigina:0,  //0 正常 1: RT-PC 进行中// 2: 完成
  orderStatus:null,
  birthdayLimt:false,
  productLimt:[],
  payLoad:{}, 
  virtual_flag:0,
  cartCheck:{},
  balanceRecord:{}
}

export default {
	state,
 	getters,
  	actions,
  	mutations,
}